export default __webpack_public_path__ + "static/media/I.035b672e.wav";